import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { CallbackState } from './callback.types';

const initialState: CallbackState = {
  name: '',
  phone: '',
  policyChecked: false,
  ui: {
    callbackOpened: false,
  },
};

export const callbackSlice = createSlice({
  name: 'callback',
  initialState,
  reducers: {
    setCallbackName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setCallbackPhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload;
    },
    toggleCallbackPolicy: (state) => {
      state.policyChecked = !state.policyChecked;
    },

    openCallback: (state) => {
      state.ui.callbackOpened = true;
    },
    closeCallback: (state) => {
      state.ui.callbackOpened = false;
    },
    clearCallback: (state) => {
      state.name = '';
      state.phone = '';
      state.policyChecked = false;
    },
  },
});

export const {
  setCallbackName,
  setCallbackPhone,
  toggleCallbackPolicy,

  openCallback,
  closeCallback,
  clearCallback,
} = callbackSlice.actions;

export const selectCallback = (state: RootState) => state.callback;

export const callbackReducer = callbackSlice.reducer;
